<template>
<v-dialog v-model="openModal" max-width="500px">
    <v-card>
        <div class="modal-header">
            <h4 class="modal-headline">{{this.title}}</h4>
            <div class="tools">
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </div>
        </div>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="8">
                        <p class="custom-label">{{ $page.props.lang.title || 'Name' }}</p>
                        <v-text-field v-model="newCategory.name" outlined dense :error-messages="responseErrors.name" @focus="responseErrors.name=''"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-btn v-if="$vuetify.breakpoint.mdAndUp" style="margin-top:23px; margin-left:20px" depressed color="primary" @click="createCategory">
                            <span>{{$page.props.lang.save || "Save"}}</span>
                        </v-btn>
                        <v-btn v-else depressed color="primary" style="margin-top:26px;" small @click="createCategory">
                            <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <div style="margin-top: 20px">
                            <v-data-table
                                :headers="headers"
                                :items="categoriesData"
                                item-key="item.id"
                                :items-per-page="5"
                                mobile-breakpoint="0"
                                hide-default-footer>
                                <template v-slot:item.name="{ item }">
                                    {{ item.name }} 
                                </template>
                                <template v-slot:item.action="{ item, index }">
                                    <v-btn @click="openEditModal(item, index)" :id="'edit' + item.id" icon>
                                        <v-icon color="#616161">mdi-pencil</v-icon>
                                        <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.edit_location || "Edit"}}</span>
                                        </v-tooltip>
                                    </v-btn>
                                    <v-btn @click="openDeleteModal(item.id, index)" :id="'delete' + item.id" icon>
                                        <v-icon color="#FF0000">mdi-delete</v-icon>
                                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.delete || "Delete"}}</span>
                                        </v-tooltip>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </div>
                </v-container>
            </v-card-text>
        </v-card>
        <v-dialog v-model="editModal" max-width="500px" style="max-height:150px; overflow:hidden;">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editLocation || "Edit location" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="8">
                                <p class="custom-label">{{ $page.props.lang.title || 'Name' }}</p>
                                <v-text-field v-model="selectedCategory.name" outlined dense :error-messages="responseErrors.name" @focus="responseErrors.name=''"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-btn v-if="$vuetify.breakpoint.mdAndUp" style="margin-top:23px; margin-left:20px" depressed color="primary" @click="edit()">
                                    <span>{{$page.props.lang.save || "Save"}}</span>
                                </v-btn>
                                <v-btn v-else depressed color="primary" style="margin-top:27px;" small @click="edit()">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ConfirmModal 
            :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
            :description="$page.props.lang.delete_confirmation_description || 'If you click YES, the location will be permanently deleted. Are you sure?'" 
            :open="deleteModal" 
            @no="deleteModal = false" 
            @yes="remove" 
            @close="deleteModal = false">
        </ConfirmModal>
    </v-dialog>
</template>

<script>
import EventBus from '@/js/eventbus'
import ConfirmModal from '@/js/Components/ConfirmModal'

export default {
    name: "ManageCategories",
    components:{
        ConfirmModal
    },
    props: {
        modal: Boolean,
        type: String,
        categories: Array,
        title: String
    },
    computed: {
        openModal: {
            get: function() {
                return this.modal
            },
            set: function() {
                this.$emit('close')
                return false
            },

            
        },
       
    },
    data() {
        return {
            headers:[
                {text: this.$page.props.lang.title || 'Name', value: 'name', sortable: false, align: 'start'},
                {text: '', value: 'action', sortable: false, align:'right'}
            ],
            categoriesData: this.categories,
            responseErrors: {},
            newCategory: {
                type: this.type,
                name: ""
            },
            editModal: false,
            deleteModal: false,
            locationToDeleteId: null,
            locationToDeleteIndex: null,
            selectedCategory:{},
            editedCategory:[],
            locationToEditIndex: null
        }

    },
    methods: {

        createCategory() {
            axios.post('/backoffice/categories/store', this.newCategory)
                .then(response => {
                    
                    if (response.data.status==="OK") {
                        this.newCategory.name = "";
                    }

                    this.categoriesData.push(response.data.category)

                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    });
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                });

        },

        openEditModal(item, index){
            this.responseErrors = {};
            this.locationToEditIndex = index;
            axios.get('/backoffice/categories/getCategory/' + item.id)
                    .then(response => {
                        if(response.data.status === "OK"){
                            this.selectedCategory = response.data.category;
                            this.editModal = true;
                        }else{
                            alert(response.data.message)
                        }
                                
                    })
        },

        edit(){
             this.responseErrors = {}
                axios.put('/backoffice/categories/update', this.selectedCategory)
                    .then(response => {
                    if (response.data.status==="OK") {
                        this.editModal = false;
                        this.editedCategory = response.data.category;
                        this.categoriesData.forEach(e => {
                            if(e.id == response.data.category.id){
                                e.name = response.data.category.name;
                            }
                        });
                       
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        
                    }
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        openDeleteModal(id,index){
            this.deleteModal = true;
            this.locationToDeleteId = id;
            this.locationToDeleteIndex = index;
        },

        remove(){
            axios.post('/backoffice/categories/delete', {id: this.locationToDeleteId})
                .then(response => {
                    
                    this.categoriesData.splice(this.locationToDeleteIndex, 1);

                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    });
                    this.deleteModal = false;
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                });

        }
    }
}
</script>
